import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export function useSetItemDetailsEffects({
    item,
    dropdownCode, 
    getInitialList,
    dispatch,
    isEquity,
    isConsignmentAdd,
    getEquityProductDetails,
    getConsignmentAddProductDetails,
    getProductDetails,
    EQUITYORDERTYPE,
    setQuantityValue,
    data,
    loading,
    selectedSegment,
    setSortDropDown,
    getSortOptionForRelatedProduct,
    isSetDetail,
}) {
    // First useEffectWithErrorLogging
    useEffectWithErrorLogging(() => { 
        if(item.bom || item.cfn){
        getInitialList({
                    item,
                    dispatch,
                    isEquity,
                    isConsignmentAdd,
                    getEquityProductDetails,
                    getConsignmentAddProductDetails,
                    getProductDetails,
                    EQUITYORDERTYPE,
                    setQuantityValue,
                    data,
                    loading,
                    selectedSegment,
                    setSortDropDown,
                    getSortOptionForRelatedProduct,
                    isSetDetail,
                });
        }        
    }, [item.bom, item.cfn, dropdownCode]);

    // Second useEffectWithErrorLogging
    useEffectWithErrorLogging(() => {
        if (data && !loading) {
            const { foundInSets, relatedProducts, billOfMaterials } = data;
            const setData = isSetDetail ? billOfMaterials : foundInSets;
            if (
                setData &&
                setData?.length > 0 &&
                !setData[0].message &&
                selectedSegment === '0'
            ) {
                setSortDropDown(false);
            } else if (
                relatedProducts &&
                relatedProducts?.length > 0 &&
                !relatedProducts[0].message &&
                selectedSegment === '1'
            ) {
                setSortDropDown(false);
                getSortOptionForRelatedProduct(selectedSegment);
            } else {
                setSortDropDown(true);
            }
        }
    }, [data, selectedSegment, isSetDetail, getSortOptionForRelatedProduct, setSortDropDown]);
}